module.exports = __webpack_public_path__ + "img/Wosscompanylogo.deaafaa9.png";